app.service('vies', function (modal, broker) {

	function init({$box, $vatNumber, $button, $country, $taxIdSelector = null,  nipEuValidate, validatedVatUeNumbers = [], onVatUeValidationUpdated}) {
		let vatNumber, country;

		if ($button.length && $vatNumber.length && $country.length) {
			$button.on('click', function () {
				if (check()) {
					load();
				}
			});
			if ($taxIdSelector) {
				$taxIdSelector.on('change', function () {
					if ($taxIdSelector.val() === 'VAT_UE' && $vatNumber.val().length > 0) {
						check();
					}
				});
			}
			$vatNumber.on('input', function () {
				check();
			});
			$country.on('change', function () {
				check();
			});

			function check(firstInit) {
				country = $country.val();
				var nip = $vatNumber.val();
				var result = false;
				if (nipEuValidate && nipEuValidate[country]) {
					result = new RegExp(nipEuValidate[country], "g").test(nip);

					if (country) {
						console.log(`reguła walidacji NIPEU dla ${country} = ${nipEuValidate[country]}`);
						$vatNumber.data('nip-rules', nipEuValidate[country])
						/*if ($nip.val().length) {
							$nip.closest('form').validate().element($nip);
						}*/
					} else {
						console.log('Brak reguły walidacyjnej dla kraju ' + country);
					}
				}
				vatNumber = nip;
				if (!firstInit) {
					$box.removeClass('active');
					if (result) {
						$button.prop('disabled', false);
					} else {
						$button.prop('disabled', true);
					}
					$button.removeClass('hide');
					$vatNumber.removeClass('is-verified');
					$box.removeClass('is-failure').removeClass('is-success');

					if (validatedVatUeNumbers.some(entry => entry[country] && entry[country].includes(vatNumber))) {
						done(true);
					} else {
						onVatUeValidationUpdated();
					}

					return result;
				}
			}

			function done(result) {

				if (result) {
					$box.removeClass('is-failure').addClass('is-success');
					$button.addClass('hide');
					$vatNumber.addClass('is-verified');
				} else {
					$box.removeClass('is-success').addClass('is-failure');
				}

				broker.trigger('VIES_VERIFICATION_FINISHED', {success: result, vatUeNumber: vatNumber, countryCode: country});
			}

			function showError() {
				modal.generate({
					id: 'vies-loading-error',
					header: 'Brak pobierania danych z rejestru VIES',
					content: 'Nie udało się pobrać danych na podstawie podanego przez Ciebie numeru NIP.',
					buttons: [{
						text: 'Rozumiem',
						click: function () {
							modal.close();
						}
					}]
				});
			}

			function load() {
				modal.generate({
					id: 'vies-loading',
					close: false,
					content: '<div>Sprawdzamy dane.<br/>Może to zająć chwilę</div>',
					callbackOpen: function () {
						$.ajax({
							url: `/check-vat.ltr?vatNumber=${vatNumber}&countryCode=${country}`,
							success: function (json) {
								if (json.status === 'VALID') {
									setTimeout(function () {		// czasowo do czasu wdrożenia top-modal z kręciołem
										modal.close();
										done(true);
									}, 400);
								} else if (json.status === 'INVALID') {
									modal.generate({
										id: 'vies-loading-error',
										header: 'Błąd walidacji w rejestrze VIES',
										content: 'Podany numer VAT UE jest nieaktywny. Nie możemy wystawić faktury na nieaktywny numer VAT UE.',
										buttons: [{
											text: 'Rozumiem',
											click: function () {
												modal.close();
											}
										}]
									});
									done(false);
								} else if (json.status === 'ERROR') {
									modal.generate({
										id: 'vies-loading-error',
										header: "Błąd walidacji w rejestrze VIES",
										content: "Nie udało się zweryfikować podanego numeru VAT UE.",
										buttons: [{
											text: 'Rozumiem',
											click: function () {
												modal.close();
											}
										}]
									});
									done(false);
								}
							}, error: function () {
								showError();
							}
						});
					}
				});
			}

			check(true);
		}
	}

	return {
		init
	};
});